export const NO_ITEM_CONTENT_ERROR =
    "Property message not present in ticket item, but it is required";
